// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import _ from 'lodash'
// import '@/assets/js/flexible'
// body样式通用引入失效
import "./assets/css/reset.scss"

//防抖
import preventClick from './clickStatefrom'  // 根据自己的路径
Vue.use(preventClick)

import Share from "vue-social-share"; //分享插件
import "vue-social-share/dist/client.css";
Vue.use(Share);


// es6 ==>>es5兼容ie
import 'babel-polyfill'
import promise from 'es6-promise';
promise.polyfill();

import vueSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'

if (!("classList" in document.documentElement)) {//ie9 table组件报错
    Object.defineProperty(HTMLElement.prototype, 'classList', {
        get: function() {
            var self = this;
            function update(fn) {
                return function(value) {
                    var classes = self.className.split(/\s+/g),
                        index = classes.indexOf(value);

                    fn(classes, index, value);
                    self.className = classes.join(" ");
                    //console.log(self.className)
                }
            }
            return {
                remove: update(function(classes, index) {

                    if (~index) classes.splice(index, 1);
                })
            };
        }
    });
}
if (window.HTMLElement) {//ie9 select
    if (Object.getOwnPropertyNames(HTMLElement.prototype).indexOf('dataset') === -1) {
        Object.defineProperty(HTMLElement.prototype, 'dataset', {
            get: function () {
                var attributes = this.attributes; // 获取节点的所有属性
                var name = [];
                var value = []; // 定义两个数组保存属性名和属性值
                var obj = {}; // 定义一个空对象
                for (var i = 0; i < attributes.length; i++) { // 遍历节点的所有属性
                    if (attributes[i].nodeName.slice(0, 5) === 'data-') { // 如果属性名的前面5个字符符合"data-"
                        // 取出属性名的"data-"的后面的字符串放入name数组中
                        name.push(attributes[i].nodeName.slice(5));
                        // 取出对应的属性值放入value数组中
                        value.push(attributes[i].nodeValue);
                    }
                }
                for (var j = 0; j < name.length; j++) { // 遍历name和value数组
                    obj[name[j]] = value[j]; // 将属性名和属性值保存到obj中
                }
                return obj; // 返回对象
            },
        });
    }
}

// 动态设置title
Vue.use(require('vue-wechat-title'))

// 暴露全局请求方法
import api from './core/api/config/index'
Vue.use(api)
//注册全局通用属性,方法
import global from '@/core/global/global'
Vue.use(global)

// 原生交互方法
import native from '@/core/native/index'
Vue.use(native)

// 通用指令
import directive from '@/core/directive/directive'
Vue.use(directive)

// 通用组件配置
import tempConfig from '@/core/tempConfig/tempConfig'
Vue.use(tempConfig)
//引入iview
import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(iView);
Vue.prototype.$Message.config({
    top: 400,
    duration: 2
});
//动态获取title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle);
//cookie插件
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

Vue.config.productionTip = false
import store from "@/core/store/index"
// import {mapState,mapMutations,mapGetters,mapActions} from "vuex"
/* eslint-disable no-new */

import * as echarts from "echarts";
// Vue.use(echarts)
Vue.prototype.$echarts = echarts;



 new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js